import React from "react";
import { CiBellOn, CiShare2 } from "react-icons/ci";
import CustomDrawer from "../Components/CustomDrawer/CustomDrawer";
import { useNavigate } from "react-router-dom";
import { Image } from "@nextui-org/react";
const Header = ({
  image,
  name,
  userName,
  onBellClick,
  onShareClick,
  notification_bell,
  endContent,
  showIcons = true,
  textSize = 24,
  showMenu = false,
  isAffiliate = false,
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-row py-4 items-center">
      {showMenu === true && <CustomDrawer />}
      <Image
        src={image}
        className="h-14 w-14 object-contain mr-2 ml-2"
        alt=""
        loading="lazy"
      />
      <div
        className="flex flex-col justify-between cursor-pointer ml-1"
        onClick={() => navigate("/store-details")}
      >
        <p
          className={` text-2xl text-[${textSize}px] font-medium text-textColor truncate-sm`}
        >
          {name}
        </p>

        <p className="text-sm font-light">
          {isAffiliate ? "An Affiliate of Wcommerce" : "A store by"}
          {!isAffiliate && (
            <span className="text-sm font-light capitalize pl-1">
              {userName}
            </span>
          )}
        </p>
      </div>
      <div className="ml-auto flex flex-row space-x-3">
        {showIcons === true && !endContent && (
          <>
            {!endContent && notification_bell && (
              <div className="w-10 h-10 rounded-lg border-2 border-gray-300 flex justify-center items-center cursor-pointer">
                <CiBellOn className="h-6 w-6" onClick={onBellClick} />
              </div>
            )}

            <div className="w-10 h-10 rounded-lg border-2 border-gray-300 flex justify-center items-center cursor-pointer">
              <CiShare2
                className="h-6 w-6 font-medium"
                onClick={onShareClick}
              />
            </div>
          </>
        )}
        {endContent && (
          <div className="w-10 h-10 rounded-lg border-2 border-gray-300 flex justify-center items-center cursor-pointer">
            {endContent}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
